import { Autocomplete, Grid, TextField } from "@mui/material";

interface FilteredNode {
  nodeId: string;
  nodeName: string;
  nodeIP: string;
}

type NodeProps = {
  index: number;
  selectedNodeId: string;
  filteredNodes: FilteredNode[];
  onChange: (node: {
    nodeId: string;
    nodeName: string;
    nodeIP: string;
  }) => void;
  error?: boolean;
  helperText?: string;
};

const DeviceTemplateNodeSelect = ({
  index,
  selectedNodeId,
  filteredNodes,
  onChange,
  error = false,
  helperText = "",
}: NodeProps) => {
  const selectedNode =
    filteredNodes.find(node => node.nodeId === selectedNodeId) ?? undefined;

  return (
    <Grid item xs={12}>
      <Autocomplete
        fullWidth
        disableClearable
        value={selectedNode}
        onChange={(_e, newNode) => {
          if (newNode) {
            onChange(newNode);
          }
        }}
        options={filteredNodes}
        getOptionLabel={option => option.nodeName}
        isOptionEqualToValue={(opt, val) => opt.nodeId === val.nodeId}
        renderInput={params => (
          <TextField
            {...params}
            label={`Node ${index + 1}`}
            error={error}
            helperText={error ? helperText : ""}
          />
        )}
      />
    </Grid>
  );
};

export default DeviceTemplateNodeSelect;
